var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 -4.28491e-09 4.97715 -9.57062e-09 10.5C-1.48563e-08 16.0228 4.47715 20.5 10 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06742 4.41211C1.28191 5.4341 0.689609 6.61203 0.344727 7.89168L5.54699 7.89168L2.06742 4.41211Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6558 7.89164C19.3109 6.61203 18.7186 5.4341 17.9331 4.41211L14.4536 7.89164L19.6558 7.89164Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.344727 13.1094C0.689648 14.389 1.28195 15.5669 2.06742 16.5889L5.54688 13.1094H0.344727Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0884 2.56746C15.0664 1.78195 13.8885 1.18965 12.6089 0.844727L12.6089 6.04695L16.0884 2.56746Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91211 18.4326C4.9341 19.2181 6.11203 19.8104 7.39164 20.1553L7.39164 14.9531L3.91211 18.4326Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3916 0.844727C6.11199 1.18965 4.93406 1.78195 3.91211 2.56742L7.3916 6.04691L7.3916 0.844727Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6089 20.1553C13.8885 19.8104 15.0664 19.2181 16.0884 18.4326L12.6089 14.9531L12.6089 20.1553Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4536 13.1094L17.9331 16.5889C18.7186 15.567 19.3109 14.389 19.6558 13.1094H14.4536Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9154 9.19566L11.3044 9.19566H11.3044L11.3044 0.584648C10.8774 0.529063 10.4421 0.5 10 0.5C9.55785 0.5 9.12262 0.529063 8.69566 0.584648L8.69566 9.19559L8.69566 9.19563L0.0846484 9.19563C0.0290625 9.62262 -9.14753e-09 10.0579 -9.57062e-09 10.5C-9.99378e-09 10.9421 0.0290625 11.3774 0.0846484 11.8043L8.69559 11.8043H8.69563L8.69563 20.4154C9.12262 20.4709 9.55785 20.5 10 20.5C10.4421 20.5 10.8774 20.471 11.3043 20.4154L11.3043 11.8044L11.3043 11.8044L19.9154 11.8044C19.9709 11.3774 20 10.9421 20 10.5C20 10.0579 19.9709 9.62262 19.9154 9.19566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6089 13.1084L17.0712 17.5708C17.2765 17.3656 17.4722 17.1511 17.659 16.9288L13.8387 13.1084H12.6089L12.6089 13.1084Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39109 13.1084H7.39102L2.92871 17.5707C3.13387 17.7759 3.34836 17.9717 3.5707 18.1585L7.39109 14.338L7.39109 13.1084Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39146 7.89117L7.39146 7.89109L2.92912 3.42871C2.72389 3.63387 2.52811 3.84836 2.34131 4.0707L6.16174 7.89113L7.39146 7.89117Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6089 7.89102L17.0713 3.42859C16.8661 3.22336 16.6516 3.02758 16.4293 2.84082L12.6089 6.66125L12.6089 7.89102Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkIcon);
export default __webpack_public_path__ + "static/media/uk-icon.783ae0fdad12c842a33678215fadcbb4.svg";
export { ForwardRef as ReactComponent };